import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { wa } from 'apps/analytics';
import { switchToDesktop, pageReloaded, setCookieAndReload } from '../actions/footer';

export default class SwitchToDesktop extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    pageReloading: PropTypes.bool.isRequired,
    stickToDesktop: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    if (this.props.pageReloading) {
      this.props.dispatch(pageReloaded());
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.pageReloading) {
      return false;
    }
    return true;
  }

  enforceDesktop = (e) => {
    e.preventDefault();
    wa.triggerPageEventWithDescription('Switching to desktop view');
    this.props.dispatch(switchToDesktop());
    setCookieAndReload();
  };

  render() {
    if (this.props.stickToDesktop || this.props.pageReloading) {
      return null;
    }
    return (
      <a className="ft-footer__desktopLink" href="/" onClick={this.enforceDesktop}>
        Desktop site
      </a>
    );
  }
}
